module.exports = __webpack_public_path__ + "static/media/curiosity.4c3c741f.svg";